import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import MedProfClientsList from '~/components/Dashboard/MedProfClientsList';

const Clients = () => {
    return (
        <>
            <Breadcrumb pageName='Clients' />
            <MedProfClientsList />
        </>
    );
};

export default Clients;
